export const pushGTMAnalyticsEvent = (eventName) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName });
};
